import ClientHubConnection = ClientHub.ClientHubConnection;
import Message = ClientHub.Message;
import UpdateTokenRequest = ClientHub.UpdateTokenRequest;
import { AppContext } from "../../Common/AppContext";
import { UriHelper } from "neo-common";
import Result = ClientHub.Result;
import { Platforms } from "neo-games";

export class WebSocketClientHub {
    private clientHubConnection: ClientHubConnection;
    private jwtToken: string;
    private connectionEstablished: boolean;
    private stackedMessages: Array<Function>;

    constructor() {
        if (AppContext.gameConfiguration == null) {
            return;
        }

        if (AppContext.gameConfiguration.ApplicationGatewayUrl === "") {
            return;
        }

        try {
            this.stackedMessages = [];
            this.connectionEstablished = false;
            this.clientHubConnection = new ClientHubConnection(
                AppContext.gameConfiguration.ApplicationGatewayUrl,
                this.getToken,
                () => {
                    this.connectionEstablished = true;
                    Platforms.Platforms.webSocketsInitialized();
                    this.sendStackedMessages();
                },
            );
            this.jwtToken = this.getToken();
        } catch (e) {
            if (DEBUG) {
                console.log("ERROR websocket connection was not created: " + e);
            }
        }
    }

    private getToken(): string {
        let token = "";

        const urlInfo: Object = UriHelper.parseUrl(window.location.href, true, true);
        if (urlInfo != null && urlInfo["hash"]) {
            token = urlInfo["hash"].substring(1).split("=")[1];
        }

        return token;
    }

    private tokenChanged(): boolean {
        const currentToken = this.getToken();
        return currentToken != this.jwtToken;
    }

    private updateToken(): void {
        if (!this.tokenChanged()) {
            return;
        }

        if (!this.clientHubConnection) {
            return;
        }

        const _self = this;
        const token = this.getToken();
        this.clientHubConnection
            .updateToken(new UpdateTokenRequest(token))
            .then(() => {
                if (DEBUG) {
                    console.log("Websocket connection token was updated successfully.");
                }
                _self.jwtToken = token;
            })
            .catch((e) => {
                if (DEBUG) {
                    console.log("ERROR websocket token was not updated: " + e);
                }
            });
    }

    private sendStackedMessages(): void {
        for (let i = 0; i < this.stackedMessages.length; i++) {
            const fn = this.stackedMessages[i];
            if (fn) {
                fn();
            }
        }

        this.stackedMessages = [];
    }

    public addMessage(message: Function): void {
        if (this.stackedMessages != null) {
            this.stackedMessages.push(message);
        }
    }

    public isConnectionEstablished(): boolean {
        return this.connectionEstablished;
    }

    public sendMessage(message: Message): Promise<void> {
        if (!this.clientHubConnection) {
            return Promise.reject(new Error("Not initialized"));
        }

        this.updateToken();
        return this.clientHubConnection.sendMessage(message);
    }

    public invokeCommand(message: Message): Promise<Result> {
        if (!this.clientHubConnection) {
            return Promise.reject({ code: "Not initialized" } as Result);
        }

        this.updateToken();
        return this.clientHubConnection.invokeCommand(message);
    }

    public onReceiveMessage(receiver: (message: Message) => void): void {
        if (!this.clientHubConnection) {
            return;
        }

        this.updateToken();
        this.clientHubConnection.onReceiveMessage(receiver);
    }

    public disconnect(): void {
        if (!this.clientHubConnection) {
            return;
        }

        this.clientHubConnection.disconnect().catch((e) => {
            console.log("ERROR websocket connection was disconnected: " + e);
        });
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Utils/WebSocketClientHub.ts
 **/